export default {
  isAuth: !!localStorage.getItem("token"),
};
